import * as RadixAvatar from "@radix-ui/react-avatar";
import type { JSX } from "react";

import { initials } from "@/lib/format";
import { cn } from "@/lib/cn";

export interface AvatarProps {
  name: string;
  src?: string | null | undefined;
  size?: "sm" | "md" | undefined;
}

const SIZE: Record<NonNullable<AvatarProps["size"]>, string> = {
  sm: "size-6 text-xs",
  md: "size-8 text-sm",
};

/** A person: photo when there is one, initials otherwise. The name is always the label. */
export function Avatar({ name, src, size = "md" }: AvatarProps): JSX.Element {
  return (
    <RadixAvatar.Root
      role="img"
      aria-label={name}
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-pill bg-surface-muted font-medium text-ink-muted select-none",
        SIZE[size],
      )}
    >
      {src === undefined || src === null || src === "" ? null : (
        <RadixAvatar.Image src={src} alt="" className="size-full object-cover" />
      )}
      <RadixAvatar.Fallback delayMs={0}>{initials(name)}</RadixAvatar.Fallback>
    </RadixAvatar.Root>
  );
}
